import { GetRegionQueryVariables } from '@catalogo/core-types';

interface CookiesAndHeader {
  cookies?: Cookies;
  headers?: Headers;
}

type Cookies = { [key: string]: string };
type Headers = { [key: string]: string };

export const getVariablesSegments = ({ cookies }: CookiesAndHeader) => {
  const customerId = cookies?.['customer.id'];
  if (!customerId) {
    return { skipSegments: true, customerId: '' };
  }
  return { skipSegments: false, customerId };
};

export const getVariablesExperiments = ({ cookies }: CookiesAndHeader) => {
  const pid = cookies?.['B2W-PID'];
  if (!pid) {
    return { skipExperiments: true };
  }
  return { skipExperiments: false, pid };
};

export const getVariablesRegion = ({
  cookies,
  headers,
}: CookiesAndHeader): GetRegionQueryVariables & { skipRegion: boolean } => {
  const isBot = !!headers?.['akamai-bot'];
  const isNotFromBR = headers?.['cdn-country'] != 'BR' && cookies?.['cdn-country'] != 'BR';
  const isCalled = !!cookies?.mesoRegion;

  const cep = cookies?.['persistentCep'];
  const lat = headers?.['cdn-lat'] || cookies?.['cdn-lat'];
  const long = headers?.['cdn-long'] || cookies?.['cdn-long'];

  if (isBot || isNotFromBR || isCalled || (!cep && !lat)) {
    return { skipRegion: true };
  }

  if (cep) {
    return { skipRegion: false, cep };
  }

  return { skipRegion: false, lat, long };
};
